import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { ProjectDatabricksStatusSection } from './ProjectDatabricksStatusSection'
import { ProjectDatabricksActionsSection } from './ProjectDatabricksActionsSection'
import { ProjectDatabricksJobsSection } from './ProjectDatabricksJobsSection'
import { ProjectDatabricksRunsSection } from './ProjectDatabricksRunsSection'
import { Link } from 'react-router'
import { useCurrentProject } from '../useCurrentProject'

export function ProjectDatabricksIntegrationPageContent() {
  const { projectId } = useCurrentProject()

  return (
    <SectionLayout>
      <div className="mb-2 text-sm">
        <Link className="text-primary underline" to={`/projects/${projectId}/databricks/notebooks`}>
          Notebooks
        </Link>
      </div>
      <ProjectDatabricksStatusSection />
      <ProjectDatabricksActionsSection />
      <ProjectDatabricksJobsSection />
      <ProjectDatabricksRunsSection />
    </SectionLayout>
  )
}
